export const attachments = () => ({
    maxWidth: 556,
});
